export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'Come ricevo Metodologia della Ricerca Pro dopo l’acquisto?',
    a: 'Riceverai l’accesso digitale ai materiali rapidamente, così potrai iniziare a utilizzarli senza attese.',
  },
  {
    q: 'Per quali livelli educativi è pensato?',
    a: 'Il materiale segue una progressione dalle basi fino a contenuti più avanzati e può essere utilizzato in differenti contesti di insegnamento della metodologia della ricerca.',
  },
  {
    q: 'È pensato soltanto per l’Italia?',
    a: 'Il materiale è scritto in italiano e costruito intorno a principi generali della metodologia della ricerca, così da poter essere utilizzato in differenti contesti formativi.',
  },
  {
    q: 'Il materiale è modificabile?',
    a: 'No. I materiali vengono forniti in formato PDF.',
  },
  {
    q: 'In quale valuta pago?',
    a: 'Il prezzo dell’offerta è 27 €.',
  },
  {
    q: 'Cosa include l’offerta da 27 €?',
    a: 'Ricevi 6 volumi completi + 5 bonus strategici + accesso digitale immediato.',
  },
  {
    q: 'È un abbonamento?',
    a: 'No. Paghi 27 € una sola volta.',
  },
  {
    q: 'Cosa succede se il prodotto non mi soddisfa?',
    a: 'Hai una garanzia di 7 giorni.',
  },
]
